<template src="./AddressModal.html"/>
<style lang='scss' scoped src="./AddressModal.scss"/>

<script>

import {
  SfBar,
  SfButton,
  SfModal,
  SfHeading
} from '@storefront-ui/vue';

import AddressForm from "@/components/MyAccount/AddressForm";
import Api from "@/api/Api";


export default {
  name: 'AddressModal',
  components: {
    AddressForm,
    SfHeading,
    SfBar,
    SfButton,
    SfModal
  },
  computed: {
    isAddressModalOpen: {
      get() {
        return this.$store.getters.isAddressModalOpen
      }
    },
  },

  methods: {
    submitAddress({address, onComplete, onError}) {

      Api.account.addAddress(address)
          .then((data) => {
            onComplete(data)
            this.$store.dispatch('addCustomerAddress', {isNew: true, address});
            this.$store.dispatch('toggleAddressModal');
          })
          .catch((e) => {
            let error = '';
            switch (e.status) {
              case 401:
                error = this.$i18n.t('errors.login.unauthorized')
                break;
              case 409:
                error = this.$i18n.t('errors.login.allReadyExist')
                break;
              case 404:
                error = this.$i18n.t('errors.login.notFound')
                break;
              case 500:
                error = this.$i18n.t('errors.server.access')
                break;
            }
            this.$store.dispatch('sendNotification', {type: 'danger', message: error, icon: 'error'});
            onError(error)
          })
    },

    toggleAddressModal() {
      this.$store.dispatch('toggleAddressModal')
    },

  }
};
</script>


